// extracted by mini-css-extract-plugin
export var productImage = "_xd-0";